'use client';
import { MultiServicePreset } from '@/types';

import { useConfig } from '@/app/contexts/ConfigContext';
import { CONTENT_MEDIA_TAG_ALL } from '@/helpers/enums';
import { ASTROLOGY_WORDING_EN } from '@/wording/astrology/ASTROLOGY_WORDING_EN';
import { FITNESS_WORDING_EN } from '@/wording/fitness/FITNESS_WORDING_EN';
import { FITNESS_WORDING_NO } from '@/wording/fitness/FITNESS_WORDING_NO';
import { LOVE_WORDING_EN } from '@/wording/love/LOVE_WORDING_EN';
import { MEDITATION_WORDING_EN } from '@/wording/meditation/MEDITATION_WORDING_EN';

interface TagsProps {
  name: string;
}

export default function Tag({ name }: TagsProps) {
  const { wording, config } = useConfig();

  let nameTranslated: string;

  // Tags/Labels use English wording as a base for consistency across languages.
  // They are translated at runtime using the selected language’s wording file.
  // If there is a menu we use the wording from hardcoded text translation to handle tags
  // Else we use the already translated tag

  // TODO if we do more multi services we should update all the wordings
  switch (name) {
    case FITNESS_WORDING_EN.text_media_1:
      nameTranslated = wording!.text_media_1;
      break;
    case FITNESS_WORDING_EN.text_media_2:
      nameTranslated = wording!.text_media_2;
      break;
    case FITNESS_WORDING_EN.page_media_content_menu_biceps:
      nameTranslated = wording!.page_media_content_menu_biceps!;
      // if (config.multiService === MultiServicePreset.FYP) {
      //   nameTranslated = FITNESS_WORDING_NO.page_media_content_menu_biceps!;
      // }
      break;
    case FITNESS_WORDING_EN.page_media_content_menu_triceps:
      nameTranslated = wording!.page_media_content_menu_triceps!;
      // if (config.multiService === MultiServicePreset.FYP) {
      //   nameTranslated = FITNESS_WORDING_NO.page_media_content_menu_triceps!;
      // }
      break;
    case FITNESS_WORDING_EN.page_media_content_menu_back:
      nameTranslated = wording!.page_media_content_menu_back!;
      // if (config.multiService === MultiServicePreset.FYP) {
      //   nameTranslated = FITNESS_WORDING_NO.page_media_content_menu_back!;
      // }
      break;
    case FITNESS_WORDING_EN.page_media_content_menu_chest:
      nameTranslated = wording!.page_media_content_menu_chest!;
      // if (config.multiService === MultiServicePreset.FYP) {
      //   nameTranslated = FITNESS_WORDING_NO.page_media_content_menu_chest!;
      // }
      break;
    case FITNESS_WORDING_EN.page_media_content_menu_legs:
      nameTranslated = wording!.page_media_content_menu_legs!;
      // if (config.multiService === MultiServicePreset.FYP) {
      //   nameTranslated = FITNESS_WORDING_NO.page_media_content_menu_legs!;
      // }
      break;
    case FITNESS_WORDING_EN.page_media_content_menu_shoulders:
      nameTranslated = wording!.page_media_content_menu_shoulders!;
      // if (config.multiService === MultiServicePreset.FYP) {
      //   nameTranslated = FITNESS_WORDING_NO.page_media_content_menu_shoulders!;
      // }
      break;
    case FITNESS_WORDING_EN.page_media_content_menu_abdominals:
      nameTranslated = wording!.page_media_content_menu_abdominals!;
      // if (config.multiService === MultiServicePreset.FYP) {
      //   nameTranslated = FITNESS_WORDING_NO.page_media_content_menu_abdominals!;
      // }
      break;
    case CONTENT_MEDIA_TAG_ALL.MEDITATION:
      nameTranslated = wording!.tag_meditation!;
      break;
    case CONTENT_MEDIA_TAG_ALL.PODCAST:
      nameTranslated = wording!.tag_podcast!;
      break;
    case MEDITATION_WORDING_EN.page_media_content_menu_antistress:
      nameTranslated = wording!.page_media_content_menu_antistress!;
      break;
    case MEDITATION_WORDING_EN.page_media_content_menu_mindfulness:
      nameTranslated = wording!.page_media_content_menu_mindfulness!;
      break;
    case MEDITATION_WORDING_EN.page_media_content_menu_energyboost:
      nameTranslated = wording!.page_media_content_menu_energyboost!;
      break;
    case MEDITATION_WORDING_EN.page_media_content_menu_mantra:
      nameTranslated = wording!.page_media_content_menu_mantra!;
      break;
    case LOVE_WORDING_EN.page_media_content_menu_compatibility:
      nameTranslated = wording!.page_media_content_menu_compatibility!;
      break;
    case LOVE_WORDING_EN.page_media_content_menu_love:
      nameTranslated = wording!.page_media_content_menu_love!;
      break;
    case ASTROLOGY_WORDING_EN.page_media_content_menu_foundations:
      nameTranslated = wording!.page_media_content_menu_foundations!;
      break;
    case ASTROLOGY_WORDING_EN.page_media_content_menu_spirituality:
      nameTranslated = wording!.page_media_content_menu_spirituality!;
      break;
    case ASTROLOGY_WORDING_EN.page_media_content_menu_tarot:
      nameTranslated = wording!.page_media_content_menu_tarot!;
      break;
    case ASTROLOGY_WORDING_EN.page_media_content_menu_psychology:
      nameTranslated = wording!.page_media_content_menu_psychology!;
      break;
    case ASTROLOGY_WORDING_EN.page_media_content_menu_trends:
      nameTranslated = wording!.page_media_content_menu_trends!;
      break;
    default:
      nameTranslated = name;
      break;
  }

  return (
    <div
      className='min-w-20 bg-zinc-100 text-neutral-800 text-xl font-medium capitalize px-2 text-center'
      style={{
        color: config.theme.textColorDark,
        backgroundColor: config.theme.tagBgColor
          ? config.theme.tagBgColor
          : config.theme.backgroundColorSecondary,
      }}
    >
      {nameTranslated}
    </div>
  );
}
